export { default as Banner } from './Banner';
export type { 
  BannerProps, 
  BannerVariant, 
  DismissibleBannerProps,
  BannerConfig,
} from './Banner';

export { default as FloatingBanner } from './variants/FloatingBanner';

export * from './legacy/ProviderBanner';

export { default as BaseBanner } from './core/BaseBanner';
export { default as BannerWithDismissal } from './core/BannerWithDismissal';

export { useBannerDismissal } from './hooks/useBannerDismissal';
export { DISMISSAL_DURATIONS, createDuration } from './constants/dismissalDurations';

export type {
  BaseBannerProps,
  BannerSize,
  BannerSeverity,
} from './types';
